import { Routes, Route } from 'react-router-dom';
import { DashboardLayout } from './layouts/DashboardLayout';
import { LoginPage } from './features/auth/pages/LoginPage';
import { ForgotPasswordPage } from './features/auth/pages/ForgotPasswordPage';
import { ResetPasswordPage } from './features/auth/pages/ResetPasswordPage';
import { HomePage } from './features/homepage/Homepage';
import { EmployeeListPage } from './features/employees/pages/EmployeeListPage';
import { EmployeeCreationPage } from './features/employees/pages/EmployeeCreationPage';
import { EmployeeDetailPage } from './features/employees/pages/EmployeeDetailPage';
import { InstanceListPage } from './features/instances/pages/InstanceListPage';
import { InstanceDetailPage } from './features/instances/pages/InstanceDetailPage';
import { InstanceEditPage } from './features/instances/pages/InstanceEditPage';
import { NotFoundPage } from './features/error/pages/PageNotFound';
import { ForbiddenPage } from './features/error/pages/ForbiddenPage';
import { EventInboxListView } from './features/eventInbox/pages/EventInboxListView';
import { UsersListPage } from './features/users/pages/UsersListPage';
import { CreateUserPage } from './features/users/pages/CreateUserPage';
import { EditUserPage } from './features/users/pages/EditUserPage';
import { UserRightsListPage } from './features/rights-profiles/pages/UserRightsListPage';
import { CreateRightsProfilePage } from './features/rights-profiles/pages/CreateRightsProfilePage';
import { EditRightsProfilePage } from './features/rights-profiles/pages/EditRightsProfilePage';
import { GeneralSettingsPage } from './features/general-settings/pages/GeneralSettingsPage';
import { EventInboxDetailView } from './features/eventInbox/pages/EventInboxDetailView';
import { ProtectedRoute } from './features/auth/components/ProtectedRoute/ProtectedRoute';
import { RequireRole } from './features/auth/components/RequireRole/RequireRole';

export function LeavesPage() {
  return <div>Leaves Page (dummy)</div>;
}

export function PayrollPage() {
  return <div>Payroll Page (dummy)</div>;
}

export function ReportingPage() {
  return <div>Reporting Page (dummy)</div>;
}

export function MyNGOPage() {
  return <div>My NGO Page (dummy)</div>;
}

export function Router() {
  return (
    <Routes>
      {/* Routes publiques */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* Routes protégées — redirigent vers /login si non authentifié */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<HomePage />} />
        <Route
          path="employees"
          element={
            <ProtectedRoute permission={{ line: 'employee_list' }}>
              <EmployeeListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="employees/create"
          element={
            <ProtectedRoute permission={{ line: 'employee_list', action: 'create' }}>
              <EmployeeCreationPage />
            </ProtectedRoute>
          }
        />
        {/* Accès à la fiche gardé DANS la page (message inline si l'utilisateur
            n'a pas `employee_record`), pas par une redirection /403 — HOMCO-640. */}
        <Route path="employees/:id" element={<EmployeeDetailPage />} />
        {/* Gouverné par la ligne `instances` du catalogue (ADR-040). */}
        <Route
          path="instances"
          element={
            <ProtectedRoute permission={{ line: 'instances' }}>
              <InstanceListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="instances/:id"
          element={
            <ProtectedRoute permission={{ line: 'instances' }}>
              <InstanceDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="instances/:id/edit"
          element={
            <ProtectedRoute permission={{ line: 'instances', action: 'modify' }}>
              <InstanceEditPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="leaves"
          element={
            <ProtectedRoute permission={{ line: 'leave_list' }}>
              <LeavesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="payroll"
          element={
            <ProtectedRoute permission={{ line: 'payslip_list' }}>
              <PayrollPage />
            </ProtectedRoute>
          }
        />
        <Route path="reporting" element={<ReportingPage />} />
        <Route path="my-ngo" element={<MyNGOPage />} />
        <Route
          path="my-ngo/general-settings"
          element={
            <ProtectedRoute permission={{ line: 'general_settings' }}>
              <GeneralSettingsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="my-ngo/users"
          element={
            <ProtectedRoute permission={{ line: 'users' }}>
              <UsersListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="my-ngo/users/create"
          element={
            <ProtectedRoute permission={{ line: 'users', action: 'create' }}>
              <CreateUserPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="my-ngo/users/:id/edit"
          element={
            // Gated on `display`, not `modify`: a read-only viewer can open the fiche;
            // the page itself renders it read-only without `users.modify` (HOMCO-623).
            <ProtectedRoute permission={{ line: 'users', action: 'display' }}>
              <EditUserPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="my-ngo/user-rights"
          element={
            <ProtectedRoute permission={{ line: 'rights_profiles' }}>
              <UserRightsListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="my-ngo/user-rights/create"
          element={
            <ProtectedRoute permission={{ line: 'rights_profiles', action: 'create' }}>
              <CreateRightsProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="my-ngo/user-rights/:id/edit"
          element={
            <ProtectedRoute permission={{ line: 'rights_profiles' }}>
              <EditRightsProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="event-inbox"
          element={
            <RequireRole role="admin">
              <EventInboxListView />
            </RequireRole>
          }
        />
        <Route
          path="event-inbox/:id"
          element={
            <RequireRole role="admin">
              <EventInboxDetailView />
            </RequireRole>
          }
        />
        <Route path="403" element={<ForbiddenPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
